import { GOOGLE_RECAPTCHA_ENTERPRISE_KEY } from '../../constants';

export const ACTION_LOGIN_SIGN_IN_BTN = 'ACTION_LOGIN_SIGN_IN_BTN';
export const ACTION_REGISTER_SIGN_IN_BTN = 'ACTION_REGISTER_SIGN_IN_BTN';

const validActions = [
  ACTION_LOGIN_SIGN_IN_BTN,
  ACTION_REGISTER_SIGN_IN_BTN,
];

function validateAction(action) {
  return validActions.includes(action);
}

/**
 * Google ReCaptcha Enterprise Helpers
 */

/**
 * @description Returns a token from Google ReCaptcha Enterprise
 *
 * @param {string} action Name of action to track.
 *
 * @returns {string}
 */

function getGoogleReCaptchaEnterpriseToken(action) {
  return new Promise((resolve) => {
    let googleReCaptchaToken = '';
    const grecaptcha = window?.grecaptcha;
    if (grecaptcha && GOOGLE_RECAPTCHA_ENTERPRISE_KEY && validateAction(action)) {
      grecaptcha.enterprise.ready(
        async () => {
          try {
            googleReCaptchaToken = await grecaptcha.enterprise.execute(
              GOOGLE_RECAPTCHA_ENTERPRISE_KEY,
              { action },
            );
            resolve(googleReCaptchaToken);
          } catch (error) {
          // Need to disable so TrackJS can log this console.error
          // eslint-disable-next-line no-console
            console.error('Error trying to get a Google ReCaptcha Enterprise token: ', error);
            resolve('');
          }
        },
      );
    }
    resolve('');
  });
}

const GoogleRecaptchaEnterprise = {
  ACTION_LOGIN_SIGN_IN_BTN,
  ACTION_REGISTER_SIGN_IN_BTN,
  getGoogleReCaptchaEnterpriseToken,
};

export default GoogleRecaptchaEnterprise;
